module.exports = __webpack_public_path__ + "img/woocommerce.31005e5c.svg";